// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2HhB5","search":"Settings_search__3VrsM","filter":"Settings_filter__2DMIJ"};